import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=b279319c&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=b279319c&prod&lang=css"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=b279319c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b279319c",
  null
  
)

export default component.exports